import { createAccessControl } from 'better-auth/plugins/access';
import { adminAc, defaultStatements } from 'better-auth/plugins/admin/access';
import type { Role } from './user';

export const accessControl = createAccessControl({
  ...defaultStatements,
  reception: ['work'],
  businessHours: ['manage'],
  users: ['manage'],
  settings: ['manage'],
  integrations: ['manage'],
  support: ['diagnose', 'signInAs'],
} as const);

export const roles = {
  receptionist: accessControl.newRole({
    reception: ['work'],
    businessHours: ['manage'],
  }),
  manager: accessControl.newRole({
    businessHours: ['manage'],
    users: ['manage'],
    settings: ['manage'],
    integrations: ['manage'],
  }),
  observer: accessControl.newRole({}),
  admin: accessControl.newRole(adminAc.statements),
  ai: accessControl.newRole({}),
};

// Held only by an ops pass, never stored, so Better Auth never sees it.
const ops = accessControl.newRole({ support: ['diagnose', 'signInAs'] });

const requests = {
  roles: { user: ['set-role'] },
  businessHours: { businessHours: ['manage'] },
  reception: { reception: ['work'] },
  users: { users: ['manage'] },
  settings: { settings: ['manage'] },
  integrations: { integrations: ['manage'] },
  diagnostics: { support: ['diagnose'] },
  signInAs: { support: ['signInAs'] },
} as const;
export type Capability = keyof typeof requests;

/** Each check asks for one resource; combined roles are additive. */
export function can(
  heldRoles: ReadonlyArray<Role>,
  capability: Capability,
): boolean {
  return heldRoles.some(
    (role) =>
      (role === 'ops' ? ops : roles[role]).authorize(requests[capability])
        .success,
  );
}
